import React from 'react';
import './LoadingPage.css';

import { damps_white, logo } from '../../theme/images';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

export default () => (
    <div id="loading-page-custom">
        <div className="loading-header">
            <img alt="loader" className="loading-header-image" src={damps_white}/>
            <h1 className="loading-header-title">
                DAMPS
            </h1>
            <h2 className="loading-header-title">
                PDGS Data Archival, Management & Processing Services
            </h2>
        </div>
        <Spinner white height={30}/>
    </div>
);